import { databases, DB_ID, COLLECTIONS, ID } from "../appwrite";
import type { Models } from "appwrite";

export interface Product {
    $id?: string;
    name: string;
    category: string;
    brand: string;
    status: string;
    description: string;
    features: string;   // comma-separated list
    imageUrl: string;
    badge: string;      // e.g. "Best Seller", "New", or ""
}

const COL = COLLECTIONS.PRODUCTS;

export const productsService = {
    list: () =>
        databases
            .listDocuments(DB_ID, COL)
            .then((r) => r.documents as unknown as Array<Product & Models.Document>),

    create: (data: Omit<Product, "$id">) =>
        databases.createDocument(DB_ID, COL, ID.unique(), data),

    update: (id: string, data: Partial<Product>) => {
        const {
            $id,
            $createdAt,
            $updatedAt,
            $permissions,
            $databaseId,
            $collectionId,
            ...updateData
        } = data as any;
        return databases.updateDocument(DB_ID, COL, id, updateData);
    },

    remove: (id: string) =>
        databases.deleteDocument(DB_ID, COL, id),
};
